"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADD_PRODUCT_TREE_NODE = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.ADD_PRODUCT_TREE_NODE = (0, gql_1.gql)(`
   mutation AddProductTreeNode(
    $productTreeNode: AddProductTreeNodeInput!
   ) {
      addProductTreeNode(
        productTreeNode: $productTreeNode
      ) {
        success
        error
        productTreeNode {
          id
          title
        }
      }
   }
`);
